module.exports = __webpack_public_path__ + "media/images/app/custom-tag-143b71f788f9e80d1ab44bba21ae850e.svg";